import BaseError from '../../error';

export class MissingFieldResponse extends BaseError {}

class FieldController {
  constructor($scope, $q, $translate, $log, $timeout) {
    "ngInject";
    this.$scope = $scope;
    this.$q = $q;
    this.$translate = $translate;
    this.$log = $log;
    this.$timeout = $timeout;

    this._translations = {};

    this.$timeout(() => {
      this.$scope.filteredOptions = this.filterOptions();
    });

    this.$scope.$watch(() => this.field.filteredOptions, () => {
      this.$scope.filteredOptions = this.filterOptions();
      this.$scope.shouldUpdateOptions = true;
    })
  }

  $onInit() {
    const promises = [];

    if (!this.fieldResponse) {
      throw new MissingFieldResponse("FieldResponse is required for Field");
    }

    promises.push(
        this._getTranslations(this.translationKeys)
          .then(translations => this._translations = translations)
    );

    return this.$q.all(promises);
  }

  $postLink() {
  }

  get fieldResponse() {
    return this._fieldResponse;
  }

  set fieldResponse(fieldResponse) {
    this._fieldResponse = fieldResponse;
  }

  get translationKeys() {
    return [
      'REQUIRED',
    ];
  }

  get value() {
    return this.fieldResponse.currentValue;
  }

  set value(value) {
    this.fieldResponse.currentValue = value;
  }

  get isEmpty() {
    return this.value === undefined || this.value === null;
  }

  stringIsEmpty(str) {
    return str === undefined || str === null || str == '';
  }

  get fieldInstance() {
    return this.fieldResponse && this.fieldResponse.fieldInstance;
  }

  get field() {
    return this.fieldInstance && this.fieldInstance.field;
  }

  get fieldType() {
    return this.field && this.field.fieldType;
  }

  get options() {
    return this.field.activeOptions;
  }

  filterOptions() {
    if (!this.field) {
      console.warn("FieldController.options - error: field not present!");
      return null;
    } else if (!this.field.activeOptions) {
      console.warn("FieldController.options - error: field.options not present!");
      return null;
    }
    let endOptions = this.field.activeOptions;
    if (this.field.filteredOptions && this.field.filteredOptions.length) {
      const filteredIds = this.field.filteredOptions
          .map(option => parseInt(option.id))
          .filter(id => !!id)
      endOptions = endOptions.filter(option => filteredIds.includes(parseInt(option.id)))
      this.fieldResponse.currentValue = null;
    }
    return endOptions;
  }

  get required() {
    return this.fieldResponse && this.fieldResponse.required;
  }

  get requiredPlaceholderText() {
    let text;
    if (this.required) {
      let s = this.translations['REQUIRED'] || 'required';
      if (s && s.toLowerCase) {
        s = s.toLowerCase();
      }
      text = `(${s})`;
    } else {
      text = '';
    }
    return text;
  }

  get translations() {
    return this._translations;
  }

  _getTranslations(translationKeys) {
    return this.$q
      .all(
        translationKeys.map(key => {
          let promise = this.$translate(key);
          return promise.then(translated => {
            return {key, translated};
          });
        })
      )
      .then(translationInfo => translationInfo.reduce((o, info) => {
        o[info.key] = info.translated;
        return o;
      }, {}))
      .catch(err => {
        this.$log.error("Error loading translations:", err);
        return this.$q.reject(err);
      });
  }

  get eventTimezoneName() {
    return this.fieldResponse && this.fieldResponse.eventTimezoneName;
  }
}

export default FieldController;
